var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 4.16602V15.8327M6.33325 14.933L11.1989 11.0405C11.6437 10.6846 11.8662 10.5067 11.9467 10.2917C12.0173 10.1032 12.0173 9.89551 11.9467 9.70702C11.8662 9.49204 11.6437 9.31409 11.1989 8.95819L6.33325 5.06569C5.63978 4.51091 5.29304 4.23352 5.00123 4.2332C4.74744 4.23293 4.50736 4.34832 4.34904 4.54666C4.16699 4.77472 4.16699 5.21877 4.16699 6.10685V13.8918C4.16699 14.7799 4.16699 15.224 4.34904 15.452C4.50736 15.6504 4.74744 15.7658 5.00123 15.7655C5.29304 15.7652 5.63978 15.4878 6.33325 14.933Z",
    stroke: "#424242",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipForward);
export default __webpack_public_path__ + "static/media/skip-forward.b7853d18f3be952cdeb9ee3a9073b692.svg";
export { ForwardRef as ReactComponent };